import { updateProfileAction } from 'redux/actions/userActions';
import { generateSimpleRequestReducer } from 'redux/utils/requestWithoutData';

export default generateSimpleRequestReducer(updateProfileAction);
